import React from "react";
import ProductList from "../Product/ProductList";
import { Link } from "react-router-dom";
const Dashboard = () => {
  return (
    <>
      <h1>Dashboard</h1>
      <Link to="/add-product" className="btn btn-primary">
        Add Product
      </Link>
      <ProductList />
    </>
  );
};

export default Dashboard;
